import styled from '@emotion/styled';
import { rem } from 'polished';
import { Box, Flex } from 'roo-ui/components';
import { H2 as DefaultH2 } from '../../primitives';

export const PointsContainer = styled(Flex)`
  align-items: center;
  display: inline-flex;
`;

export const LogoContainer = styled(Box)`
  max-width: 120px;
  padding-right: 6px;
`;

export const DataContainer = styled(Box)`
  padding-left: 6px;
`;

export const H2 = styled(DefaultH2)`
  font-size: ${rem(14)};
  line-height: 20px;
  margin: 0;
`;
